const APIHOST = (process.env.NODE_ENV === "development") ? "https://www.christmaslistapp.com/api2" : "https://www.christmaslistapp.com/api2";


function handleErrors(response) {
    if (!response.ok) {
        throw response;
    }
    return response;
}

export function getUserGiftlist(userId, token) {
    console.log('GETTING GIFT LIST...', userId);
    return fetch(APIHOST + "/wishlists/" + userId, {
        headers: {
            'X-Cla-Authorization': token, 
            'Content-Type': 'application/json'
        }
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('MY ERR', err);
        return err;
    });
    
}

export function getUserNicelist(userId, token) {
    console.log('GETTING NICE LIST...', userId);
    return fetch(APIHOST + "/nicelist/" + userId, {
        headers: {
            'X-Cla-Authorization': token, 
            'Content-Type': 'application/json'
        }
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('MY ERR', err);
        return err;
    });
    
}

export function getUserSuggested(userId, token) {
    console.log('GETTING SUGGESTED LISTS...', userId);
    return fetch(APIHOST + "/suggested/" + userId, {
        headers: {
            'X-Cla-Authorization': token, 
            'Content-Type': 'application/json'
        }
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('MY ERR', err);
        return err;
    });
    
}

export function getParsedUrl(urlToParse, token) {
    console.log('PARSE URL...', urlToParse);

    return fetch(APIHOST + "/urlparse", {
        headers: {
            'X-Cla-Authorization': token, 
            'Content-Type': 'application/json'
        },
        method: 'POST', 
        body: JSON.stringify({
            url: urlToParse
        })
    })
    .then(handleErrors)
    .then(res => {
        return res.json();
    }).catch( err => {
        console.log('MY ERR', err);
        return err;
    });
    
}

export function addItem(data, token) {
    console.log('ADDING ITEM...', data);
    return fetch(APIHOST + "/item", 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
            method: 'POST', 
            body: JSON.stringify(data) 
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('MY ERR', err);
            return err;
        });   
}

export function copyItem(data, token) {
    console.log('COPYING ITEM...', data);
    return fetch(APIHOST + "/itemcopy", 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
            method: 'POST', 
            body: JSON.stringify(data) 
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('MY ERR', err);
            return err;
        });   
}

export function updateItem(data, token) {
    console.log('EDITING ITEM...', data.itemID);
    return fetch(APIHOST + "/item/" + data.itemID, 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
            method: 'POST', 
            body: JSON.stringify(data) 
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('MY ERR', err);
            return err;
        });
    
}

export function removeItem(itemID, token) {
    console.log('REMOVING ITEM...', itemID);
    return fetch(APIHOST + "/item/" + itemID, 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
            method: 'DELETE', 
            body: ''
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('MY ERR', err);
            return err;
        });
    
}

